import BodyModalWithActions from '../../../../components/common/modals/bodyModalWithActions'
import { Typography, SxProps, Theme } from '@mui/material'
import ContainedButton from '../../../../components/common/buttons/containedButton'

interface Props {
  handleClose: () => void
  sx?: SxProps<Theme> 
}
const BodyModalErreur = ({ handleClose, sx }: Props) => {
  return (
    <BodyModalWithActions
      title='Aucune date disponible'
      type='warning'
      content={
            <Typography variant='body1'>Cette formation n’est malheureusement pas offerte à d’autres dates pour le moment.</Typography>
      }
      sx={{...sx}}
      actions={
        <>
          <ContainedButton
            variant='secondary'
            title='OK'
            handleClick={handleClose}
          />
        </>
      }
    />
  )
}

export default BodyModalErreur
